import { useColorModeValue } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { CustomInputSelect } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import AppLoader from '@Modules/core/components/Loader';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import React from 'react';
import { useForm } from 'react-hook-form';
import { IUsersProfileFormMeta } from '../../containers/formHandlers/UsersProfileFormHandle/UsersProfileFormMeta';

type Props = {
  onSubmit: any,
  meta: IUsersProfileFormMeta,
  isLoading: boolean,
  isSubmitting: boolean,
};

export default React.forwardRef(function UsersProfileFormUI(
  { onSubmit, meta, isLoading, isSubmitting }: Props,
  ref: any
) {
  const submitBtnRef = React.useRef<any>(null);
  const textColor = useColorModeValue('gray.500', 'gray.300');

  const {
    // register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  React.useImperativeHandle(ref, () => ({
    submitBtnRef,
  }));

  return (
    <>
      <form ref={ref} onSubmit={handleSubmit(onSubmit)}>
        <CC.Box>
          <CC.Text mb="4" color="gray.600">
            Remplissez les informations de base du profile
            {isLoading && <AppLoader />}
          </CC.Text>

          <CC.Box w="full" mt="4" mb="8" color={textColor}>
            <CC.Flex
              w="full"
              mb="2"
              flexDirection={{ base: 'column', md: 'row' }}
            >
              <CC.FormControl mr="2">
                <CustomFormControl isInvalid={!!errors[meta.profile.name]} label={meta.profile.label}>
                  <CustomInputSelect meta={meta.profile} />
                </CustomFormControl>
              </CC.FormControl>
            </CC.Flex>

            <CC.Flex
              w="full"
              flexDirection={{ base: 'column', md: 'row' }}
              mt={{ base: 2 }}
            >
              {/* <CC.FormControl mr="2" mt={{base: 2, md: 0}}>
              <CC.FormLabel>Description</CC.FormLabel>
              <CustomTextInput
                meta={meta.descriptionMeta}
                register={register(meta.descriptionMeta.name)}
                hasError={errors[meta.descriptionMeta.name]}
              />
            </CC.FormControl> */}

              <CC.FormControl w="full" mt={{ base: 2, md: 0 }} mr="2">
                <CustomFormControl isInvalid={!!errors[meta.bank.name]} label={meta.bank.label}>
                  <CustomInputSelect meta={meta.bank} />
                </CustomFormControl>
              </CC.FormControl>

              <CC.FormControl mt={{ base: 2, md: 0 }} ml="2">
                <CustomFormControl isInvalid={!!errors[meta.agence.name]} label={meta.agence.label}>
                  <CustomInputSelect meta={meta.agence} />
                </CustomFormControl>
              </CC.FormControl>
            </CC.Flex>
          </CC.Box>

          <button
            ref={submitBtnRef}
            type="submit"
            style={{ display: 'none' }}
          ></button>

          {/* <CC.Flex justify={'flex-end'}> */}
          {/* <CustomButton loading={isSubmitting} type="submit" >
            Sauvegarder
          </CustomButton> */}

          {/* <CustomButton type="button">
            {isLoading ? (
              <AppLoader />
            ) : (
              <span>Sauvegarder et continuer</span>
            )}
          </CustomButton> */}
          {/* </CC.Flex> */}
        </CC.Box>
      </form>
    </>
  );
});
